export const my_recipe = {
    recipe_1: {
      name: 'Chirashi Don',
      preparation_time: '30 minutes',
      servings: '2',
      ingredients: [
        '1/2 cup rice',
        '1/2 cup water',
        '2 eggs',
        '300g of salmon, tuna and salmon roe',
      ],
      instructions: [
        'Cook rice and water in a rice cooker',
        'Fry eggs in a pan',
        'Serve rice, eggs and fish on a plate',
      ],
   
    },
    recipe_2: {
        name: 'Chicken Biryani',
        preparation_time: '30 minutes',
        servings: '2',
        ingredients: [
          '1/2 kg Chicken',
          '1/2 cup rice',
          '1/2 cup water',
          '300g of salt, pepper and dryfruit',
        ],
        instructions: [
          'Prepare rice by cooking in cooker',
          'Prepare chicken',
          'mix both rice and chicken',
          'Serve rice, eggs and fish on a plate',
        ],
     
      },
  }